import { TASK_PRIORITIES, TASK_STATUS } from "@/utils/constants";

interface TaskFiltersProps {
  filters: any;
  setFilters: (filters: any) => void;
  filterCounts: Record<string, any>;
  fetchTasks: (filters?: any) => void;
}
interface Tab {
  id: string;
  label: string;
  count: number;
  time: string;
  color: string;
  number: number;
  priority?: boolean;
}

export const TaskFilters: React.FC<TaskFiltersProps> = ({
  filters,
  setFilters,
  filterCounts,
  fetchTasks,
}) => {
  const activeStatusTab = filters.status || "";
  const activePriorityTab = filters.priority || "";

  const tabs = [
    {
      id: "To Do",
      label: "To Do",
      count: filterCounts?.[TASK_STATUS.TODO]?.count || 0,
      time: filterCounts?.[TASK_STATUS.TODO]?.totalTime
        ? `${filterCounts[TASK_STATUS.TODO].totalTime}m`
        : "0m", 
      color: "badge-todo",
      number: 1,
    },
    {
      id: "In Review",
      label: "My Review",
      count: filterCounts?.[TASK_STATUS.IN_REVIEW]?.count || 0,
      time: filterCounts?.[TASK_STATUS.IN_REVIEW]?.totalTime
        ? `${filterCounts[TASK_STATUS.IN_REVIEW].totalTime}m`
        : "0m",
      color: "badge-in-review",
      number: 2,
    },
    {
      id: "In Review By Others",
      label: "Review By Others",
      count: filterCounts?.[TASK_STATUS.IN_REVIEW_BY_OTHERS]?.count || 0,
      time: filterCounts?.[TASK_STATUS.IN_REVIEW_BY_OTHERS]?.totalTime
        ? `${filterCounts[TASK_STATUS.IN_REVIEW_BY_OTHERS].totalTime}m`
        : "0m",
      color: "badge-in-review",
      number: 3,
    },
    {
      id: "In Process",
      label: "In Process",
      count: filterCounts?.[TASK_STATUS.IN_PROCESS]?.count || 0,
      time: filterCounts?.[TASK_STATUS.IN_PROCESS]?.totalTime
        ? `${filterCounts[TASK_STATUS.IN_PROCESS].totalTime}m`
        : "0m", 
      color: "badge-in-process",
      number: 4,
    },
    {
      id: "Help Required", 
      label: "Help Required",
      count: filterCounts?.[TASK_STATUS.HELP_REQUIRED]?.count || 0,
      time: filterCounts?.[TASK_STATUS.HELP_REQUIRED]?.totalTime
        ? `${filterCounts[TASK_STATUS.HELP_REQUIRED].totalTime}m`
        : "0m",
      color: "badge-help-required",
      number: 5,
    },
    {
      id: "Help Required By Others",
      label: "Help Required By Others",
      count: filterCounts?.[TASK_STATUS.HELP_REQUIRED_BY_OTHERS]?.count || 0,
      time: filterCounts?.[TASK_STATUS.HELP_REQUIRED_BY_OTHERS]?.totalTime
        ? `${filterCounts[TASK_STATUS.HELP_REQUIRED_BY_OTHERS].totalTime}m`
        : "0m",
      color: "badge-help-required",
      number: 6,
    },
    {
      id: "Completed",
      label: "Completed",
      count: filterCounts?.[TASK_STATUS.COMPLETED]?.count || 0, 
      time: filterCounts?.[TASK_STATUS.COMPLETED]?.totalTime
        ? `${filterCounts[TASK_STATUS.COMPLETED].totalTime}m`
        : "0m",
      color: "badge-completed",
      number: 7,
    },
    {
      id: "Archived",
      label: "Archived",
      count: filterCounts?.[TASK_STATUS.ARCHIVED]?.count || 0,
      time: filterCounts?.[TASK_STATUS.ARCHIVED]?.totalTime
        ? `${filterCounts[TASK_STATUS.ARCHIVED].totalTime}m`
        : "0m",
      color: "badge-archived ",
      number: 8,
    },

  ];

  const priority = [
      {
      id: "Low",
      label: "Low Priority",
      count: filterCounts?.[TASK_PRIORITIES.LOW]?.count || 0,
      time: filterCounts?.[TASK_PRIORITIES.LOW]?.totalTime
        ? `${filterCounts[TASK_PRIORITIES.LOW].totalTime}m`
        : "0m",
      color: "badge-low ",
      number: 8,
      priority: true,
    },
    {
      id: "Medium", 
      label: "Medium Priority",
      count: filterCounts?.[TASK_PRIORITIES.MEDIUM]?.count || 0, 
      time: filterCounts?.[TASK_PRIORITIES.MEDIUM]?.totalTime
        ? `${filterCounts[TASK_PRIORITIES.MEDIUM].totalTime}m`
        : "0m",
      color: "badge-medium ",
      number: 8,
      priority: true,
    },
    {
      id: "High", // Backend priority value
      label: "High Priority",
      count: filterCounts?.[TASK_PRIORITIES.HIGH]?.count || 0,
      time: filterCounts?.[TASK_PRIORITIES.HIGH]?.totalTime
        ? `${filterCounts[TASK_PRIORITIES.HIGH].totalTime}m`
        : "0m",
      color: "badge-high",
      number: 8,
      priority: true,
    },
  ]

  const handleTabClick = (tab: Tab) => {
    let newFilters;

    if (tab.priority) {
      const newPriority = activePriorityTab === tab.id ? "" : tab.id;
      newFilters = { ...filters, priority: newPriority, status: "" };
    } else {
      const newStatus = activeStatusTab === tab.id ? "" : tab.id;
      newFilters = { ...filters, status: newStatus, priority: "" };
    }

    setFilters(newFilters);
    fetchTasks(newFilters);
  };

  const isTabActive = (tab: Tab) => {
    if (tab.priority) {
      return tab.id === activePriorityTab;
    } else {
      return tab.id === activeStatusTab;
    }
  };
  return (
    <div className="space-y-3">
      <div className="flex flex-nowrap sm:flex-wrap items-center space-x-[10px] space-y-0">
        {tabs.map((tab) => (
          <button
            key={`${tab.id}-${tab.number}`}
            onClick={() => handleTabClick(tab)}
            className={`
              relative border flex items-center space-x-1 px-2 py-1 rounded-md text-sm font-medium whitespace-nowrap
              ${
                isTabActive(tab)
                  ? `${tab.color} border-1 border-blue-500 shadow-xl transform -translate-y-1`
      : `${tab.color} `
              }
            `}
          >
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-gray-400 text-white text-xs rounded-full flex items-center justify-center leading-none">
              {tab.number}
            </span>
            <span>{tab.label}</span>
            <span className="font-semibold">{tab.count}</span>
            <span>({tab.time})</span>
          </button>
        ))}
      </div>
      <hr />
      <div className="flex flex-nowrap sm:flex-wrap items-center space-x-[10px] space-y-0">
        {priority.map((tab) => (
          <button
            key={`${tab.id}-${tab.number}`}
            onClick={() => handleTabClick(tab)}
            className={`
              relative border flex items-center space-x-1 px-2 py-1 rounded-md text-sm font-medium whitespace-nowrap
              ${
                  isTabActive(tab)
                  ? `${tab.color} border-1 border-blue-500 shadow-xl transform -translate-y-1`
      : `${tab.color} `
              }
            `}
          >
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-gray-400 text-white text-xs rounded-full flex items-center justify-center leading-none">
              {tab.number}
            </span>
            <span>{tab.label}</span>
            <span className="font-semibold">{tab.count}</span>
            <span>({tab.time})</span>
          </button>
        ))}
      </div>
    </div>
  );
};
